import { createAsyncThunk, Dispatch } from '@reduxjs/toolkit';
import {
  deleteInvitation,
  fetchInvitationsList,
  reactivateInvitation,
  addInvitation,
} from 'api/InvitationLinksList';
import { AppDispatch } from 'app/store';
import { MyKnownError, thunkErrorHandler } from 'features/thunkError';
import {
  IFetchInvitationsParams,
  IInvitation,
  IAddInvitationData,
} from './invitationLinksListTypes';
import { toast } from 'react-toastify';
import { removeInvitationReducer } from './invitationLinksListSlice';

export const getInvitations = createAsyncThunk<
  { list: IInvitation[]; count: number },
  IFetchInvitationsParams | void,
  {
    dispatch: AppDispatch;
    rejectValue: string | unknown;
  }
>('@@invitationLinksList/getInvitations', async (params, thunkApi) => {
  try {
    const res = await fetchInvitationsList(params);
    return res.data;
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});

export const getInvitationsInfiniteScroll = createAsyncThunk<
  { list: IInvitation[]; count: number },
  IFetchInvitationsParams | void,
  {
    dispatch: AppDispatch;
    rejectValue: string | unknown;
  }
>('@@invitationLinksList/getInvitationsInfiniteScroll', async (params, thunkApi) => {
  try {
    const res = await fetchInvitationsList(params);
    return res.data;
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});

export const createInvitations = createAsyncThunk<
  IInvitation[],
  IAddInvitationData[],
  {
    dispatch: AppDispatch;
    rejectValue: string | unknown;
  }
>('@@invitationLinksList/inviteUser', async (invitationData, thunkApi) => {
  try {
    const res = await addInvitation(invitationData);
    if (res.status === 200) {
      toast.success('Invitation created!');
    }
    return res.data;
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});

export const reactivateUnusedInvitation = createAsyncThunk<
  IInvitation,
  number,
  {
    dispatch: AppDispatch;
    rejectValue: string | unknown;
  }
>('@@invitationLinksList/reactivateInvitation', async (inviteId, thunkApi) => {
  try {
    const res = await reactivateInvitation(inviteId);
    if (res.status === 200) {
      toast.success('Invitation resent!');
    }
    return res.data;
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});

export const deleteUnusedInvitation = createAsyncThunk<
  void,
  number,
  {
    dispatch: Dispatch;
    rejectValue: string | unknown;
  }
>('@@invitationLinksList/deleteInvitation', async (inviteId, thunkApi) => {
  try {
    const res = await deleteInvitation(inviteId);
    if (res.status === 204) {
      thunkApi.dispatch(removeInvitationReducer(inviteId));
      toast.success('Invitation deleted!');
    }
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});
